import { render, staticRenderFns } from "./OperatorLayout.vue?vue&type=template&id=4cefe57b&scoped=true"
import script from "./OperatorLayout.vue?vue&type=script&lang=js"
export * from "./OperatorLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cefe57b",
  null
  
)

export default component.exports